const frequencyPeriod = {
  SECOND: 'second',
  MINUTE: 'minute',
  HOUR: 'hour',
  DAY: 'day',
}

const maxWidth = {
  SMALL: '320px',
  MEDIUM: '400px',
  LARGE: '560px',
  EXTRA_LARGE: '720px',
  EXTRA_EXTRA_LARGE: '1020px',
}

const type = {
  COLUMN: 'column',
  IMAGE_COLUMN: 'imageColumn',
  FORTUNE_WHEEL: 'fortuneWheel',
}

const ribbonType = {
  GIFT: 'gift',
  TEXT: 'text',
}

const trigger = {
  AUTO: 'auto',
  RIBBON: 'ribbon',
  TIME: 'time',
  EXIT_INTENT: 'exitIntent',
}

const animation = {
  FADE: 'fade',
  SLIDE: 'slide',
  ZOOM: 'zoom',
}

const position = {
  TOP_LEFT: 'topLeft',
  TOP_CENTER: 'topCenter',
  TOP_RIGHT: 'topRight',
  CENTER_LEFT: 'middleLeft',
  CENTER: 'center',
  CENTER_RIGHT: 'middleRight',
  BOTTOM_LEFT: 'bottomLeft',
  BOTTOM_CENTER: 'bottomCenter',
  BOTTOM_RIGHT: 'bottomRight',
};

export { type, frequencyPeriod, maxWidth, ribbonType, trigger, position, animation }